import {customElement, bindable} from 'aurelia-framework';

@customElement('loader')
export class Loader {
	@bindable message;	
}